import request from '@/utils/request'

export const getRegions = (parentId) =>
  request({
    url: '/insurance/category/list',
    method: 'get',
    params: { parentId }
  })
